import React, { Component } from 'react';
import { CloseOutlined, UserOutlined, InfoCircleFilled } from '@ant-design/icons';
import { Upload, Modal, Tooltip, Button, Spin, Divider, Checkbox, Avatar, Empty, Select } from 'antd';
import moment from 'moment';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import otmpostService from '../../../services/otmhttpService';
import Storage from './../../../services/local-store';
import userTrackService from './../../../services/usertrack-service';
import { financialClearanceSchema } from '../../../schema/financial-counselling';
import RadioButtonLayer from '../../../components/FormComponent/Input/radioButton';
import ReactToPrint from "react-to-print";
const $ = require('jquery');
let { addFinancialClearance, updateFinancialClearanceinOTMApp, getCounsellorCommentsByPatient,getProceduresforFCApp } = networkList
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]
const { Option } = Select;

class Finanical_clearance extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': false,
            'showDocument': false,
            patientDocument: [],
            body: {},
            tbody: [],
            thead: [{
                "key": 's_no',
                'label': '#'
            }, {
                "key": 'document_description',
                'label': 'Document Description'
            }, {
                "key": 'action',
                'label': 'Upload'
            }, {
                "key": 'submited_files',
                'label': 'Submitted Files'
            }],
            fileList: [],
            disable_15days: false,
            latest_counselling_id: null,
            current_counselling_id: null,
            formData: [],
            counselled_by: null,
            counselled_date: null,
            clearance_id: null,
            remarks: null,
            remarks_input: null,
            clearance: null,
            selected_clearance: null,
            commentsArray: [],
            basicDetails:[],
            financialPrintVisable:false,
            finanacialData:[],
            fetching: false,
            selected_proceure: [],
            show_error: false,
            procedureList: [],
            appointment_ids : []
        }
    }


    componentDidMount() {
        let formSchema = Object.assign({}, financialClearanceSchema);
        this.setState({ formData: formSchema['feilds'],appointment_ids:[],selected_proceure:[] })
        this.initial();
        // setTimeout(() => { this.initial() }, 1000)
    }

    componentWillUnmount() {
        this.setState({
            visible: false,
            financialPrintVisable:false

        });
    }
    componentDidUpdate(prevProps) {

        if (this.props.mydata !== prevProps.mydata) {
            this.initial()
            // this.setState({modal1Visible: true});
            console.log("updated selected countries", this.props.mydata);
        }
    }

    initial() {
        // this.getMasterDocumentTypes();
        const { id, slug } = this.props.match.params
        if (slug === 'patients-history-details') {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        } if (slug === 'pending-docs') {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        }
        if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
            let tokenData = JSON.parse(Storage.get('current_token'));
            if (tokenData && tokenData['umr']) {
                this.setState({ showDocument: true, ui_form_type: 'add' });
                this.getPatientDocumentDetails();
            } else {
                this.setState({ showDocument: false, ui_form_type: 'add' })
            }
        }
        if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            // let view = JSON.parse(Storage.get('counselling_view'));
            // if (view && view[0]['umr']) {
                let umr = localStorage.getItem('UMRVALUE');
            if (umr) {
                this.setState({ showDocument: true, ui_form_type: 'view' });
                this.getPatientDocumentDetails();
            } else {
                this.setState({ showDocument: false, ui_form_type: 'view' });
            }
        }
    }

    // getMasterDocumentTypes() {
    //     this.setState({ loadding: true })
    //     let { getMasterDocumentTypes } = networkList;
    //     try {
    //         postService(getMasterDocumentTypes, 'GET', {}).then(res => {
    //             if (res['status']) {
    //                 this.setState((state) => ({ 'tbody': res['data'] }));
    //                 this.setState({ loadding: false })
    //                 Storage.store('getMasterDocumentTypes', res['data'])
    //             } else {
    //                 this.setState((state) => ({ 'docTypes': [] }));
    //                 this.setState({ loadding: false })
    //             }
    //         });
    //     } catch (error) {
    //         console.log(error);
    //         this.setState((state) => ({ 'loadding': false }));
    //         Modal.error({
    //             title: 'Error Message',
    //             content: 'Oops, Something is wrong. Please try again.',
    //         })

    //     }
    // }

    getPatientDocumentDetails(from_type) {
        this.setState({ loadding: true })
        let { getFinancialClearanceDetails } = networkList;
        let { id, slug } = this.props.match.params
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
            slug = 'recounselling';
        }
        let tokenData = JSON.parse(Storage.get('current_token'));
        let user_data = JSON.parse(Storage.get('user_data'));
        let view = JSON.parse(Storage.get('counselling_view'));
        let payload = {}

        if (slug === 'patients-history-details') {
            let yes = this.props.mydata ? this.props.mydata : false
            console.log('13:', this.props.mydata)
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                        console.log('disable_15days', disable_15days, days)
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': counselling_id })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        if (slug === 'pending-docs') {
            let yes = this.props.mydata ? this.props.mydata : false
            console.log('pending-docs:', this.props.mydata)
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                        console.log('disable_15days', disable_15days, days)
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': parseInt(counselling_id) })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        // add counselling
        if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
            payload = { "umr_no": tokenData['umr'], "ip_no": tokenData['ip'], "unit_id": user_data['unitid'], "form_type": "add", "counselling_id": '' }
            this.setState({ "umr_no": tokenData['umr'], "ip_no": tokenData['ip'], "patient_name": tokenData['patient_name'], ui_form_type: 'add' })
        }
        // view counselling
        if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling' || slug==='recounselling') {
            const params = new URLSearchParams(this.props.location.search);
            let ui_counselling_id = params.get('cid');
            if(slug==='recounselling'){
                ui_counselling_id = params.get('rid');
            }
            // let current_counselling_id = from_type!=='add' ? this.props.print_counselling_id || ui_counselling_id || '':'';
            let current_counselling_id = from_type!=='add' ? this.props.print_counselling_id : '';
            let disable_15days = null
            if (view&&view.length>0 &&view[0]['counselling_date']) {
                var days = Math.abs((moment(view[0]['counselling_date']).diff(moment(new Date()), 'day')));
                disable_15days = days > 15 ? true : false
                console.log('disable_15days', disable_15days, days)
            } else {
                disable_15days = false
            }
            let umr = localStorage.getItem('UMRVALUE');
            console.log('umr+++', umr)
            let viewArray = view || [];
            //payload = { "umr_no":  view.length>0&&view[0]['umr'], "ip_no":  view.length>0&&view[0]['ip_number'], "unit_id": user_data['unitid'], "form_type": from_type!=='add'?"view":'add', "counselling_id": current_counselling_id }
            let ip_no = viewArray.length > 0 && viewArray[0]['ip_number'] ? viewArray[0]['ip_number'] : ''
            payload = { "umr_no": umr, "ip_no":  ip_no, "unit_id": user_data['unitid'], "form_type": from_type!=='add'?"view":'add', "counselling_id": current_counselling_id }
            console.log('PAYLOAD::::', payload, umr);
            this.setState({ "umr_no":  viewArray.length>0&&viewArray[0]['umr'], "ip_no":  viewArray.length>0&&viewArray[0]['ip_number'], "patient_name":  viewArray.length>0&&viewArray[0]['patient_name'], 'disable_15days': disable_15days, ui_form_type: 'view', 'current_counselling_id': current_counselling_id })
        }
        try {
            const Userlogobj = {
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "get Patient Financial Clearance - Request",
                    "date": new Date(),
                    "meta": payload
                }
            }
            userTrackService(Userlogobj);
            postService(getFinancialClearanceDetails, 'POST', { "data": payload }).then(res => {
                const Userlogobjres = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "get Patient Financial Clearance - Response",
                        "date": new Date(),
                        "meta": res
                    }
                }
                userTrackService(Userlogobjres);
                if (res['status']) {
                    this.commentsHistory()
                    let latest_cou_id = res['latest_counselling_id'] ? res['latest_counselling_id'] : null
                    let { formData } = this.state
                    if (res['data'].length > 0) {
                        formData.map((form, key) => {
                            form.data.map((radio, key2) => {
                                if (res['data'][0]['financial_clearance'] === 'yes') {
                                    formData[key]['data'][key2]['value'] = 'Yes'
                                    formData[key]['data'][1]['value'] = null
                                    formData[key]['data'][key2]['disable'] = this.state.disable_15days
                                } else if (res['data'][0]['financial_clearance'] === 'no') {
                                    formData[key]['data'][key2]['value'] = 'No'
                                    formData[key]['data'][0]['value'] = null
                                    formData[key]['data'][key2]['disable'] = this.state.disable_15days
                                }
                            })
                        })
                    } else {
                        formData.map((form, key) => {
                            form.data.map((radio, key2) => {
                                formData[key]['data'][key2]['value'] = null
                                formData[key]['data'][key2]['disable'] = this.state.disable_15days
                            })
                        })
                    }
                    this.setState((state) => ({ formData: formData, 'clearance_id': res['data'].length > 0 ? res['data'][0]['clearance_id'] : null, 'latest_counselling_id': latest_cou_id, 'counselled_by': res['data'].length > 0 ? res['data'][0]['clearance_by'] : null, 'counselled_date': res['data'].length > 0 ? res['data'][0]['updated_at'] || res['data'][0]['created_at'] : null, 'remarks': res['data'].length > 0 ? res['data'][0]['remarks'] : null, 'clearance': res['data'].length > 0 ? res['data'][0]['financial_clearance'] : null,finanacialData:res['data'] }));
                    this.setState({ loadding: false })
                    Storage.store('getPatientDocumentDetails', res['data'])
                } else {
                    this.setState((state) => ({ 'patientDocument': [],finanacialData:[] }));
                    this.setState({ loadding: false })
                }
            });
            let basicDetail=[]
            basicDetail=this.props.counselling_details?this.props.counselling_details:[] ;
            this.setState({basicDetails:basicDetail})
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })

        }
    }

    resetModalState = () => {
        this.setState({
            remarks_input: '',
            selected_proceure: [],
            show_error: false,
            procedureList:[]
        });
    };

    setModal1Visible = (visible) => {
        this.setState({modal1Visible:visible,remarks_input: null,procedureList: [],selected_proceure: [],appointment_ids: [],selected_clearance: null});
        if (!visible) {
            this.resetModalState();
        }
    }
    handleChange = (data) => {
        let { formData } = this.state
        if (data) {
            formData.map((form, key) => {
                form.data.map((radio, key2) => {
                    if (data['value'] === 'yes') {
                        formData[key]['data'][key2]['value'] = 'Yes'
                        formData[key]['data'][1]['value'] = null
                    } else if (data['value'] === 'no') {
                        formData[key]['data'][key2]['value'] = 'No'
                        formData[key]['data'][0]['value'] = null
                    }
                })
            })
            this.setState({ 'selected_clearance': data['value'], 'formData': formData })
        }
    };

    fc_submit = () => {
        this.setState({ loadding: true })

        let user_data = null
        let { id, slug } = this.props.match.params;
        let { umr_no, ip_no, body, clearance_id, clearance, selected_clearance, remarks_input, remarks, basicDetails } = this.state;
        let clearance_text = selected_clearance || clearance || null
        let remarks_text = remarks_input || null
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
            slug = 'recounselling';
        }

        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        } else {
            Modal.error({
                title: `Failure`,
                content: `unit in null.`,
                zIndex: '1022'
            });
        }
        console.log('FC Insurance', this.state)
        if (this.state.appointment_ids.length === 0) {
            Modal.error({
                title: `Failure`,
                content: `Cannot submit Without Selecting Surgeries.`,
                zIndex: '1022'
            });
            this.setState({loadding:false});
            return;
        }
        if(slug === 'view-finanical-counselling'){
            if (clearance_text && (this.state.basicDetails.umr || umr_no || this.props.counselling_details.umr) && user_data['unitid']) {
                if (remarks_text && remarks_text.length > 12) {
                    let payload = {};
                    let umr = localStorage.getItem('UMRVALUE');
                    var current_counselling_id = '';
                    payload['financial_clearance'] = clearance_text;
                    payload['remarks'] = remarks_text;
                    //payload["umr"] = umr_no;
                    payload["umr"] = umr;
                    // if (body['document_type'] === 'KYC') {
                    //     payload["ip_number"]= null;
                    // } else {
                    payload["ip_number"] = this.state.basicDetails.ip_no ? this.state.basicDetails.ip_no : ip_no ? ip_no : null;
                    // }
                    // payload["document_short_code"]= body.document_short_code;
                    // payload["document_id"]= doc_id;
                    payload["unit_id"] = user_data['unitid'];
                    if (slug === 'patients-history-details') {
                        payload["form_type"] = 'view';
                        let yes = this.props.mydata ? this.props.mydata : false;
                        if (yes) {
                            let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                            payload["counselling_id"] = counselling_id;
                            payload["clearance_id"] = clearance_id ? clearance_id : null;
                        }
                    }
                    if (slug === 'pending-docs') {
                        payload["form_type"] = 'view';
                        let yes = this.props.mydata ? this.props.mydata : false;
                        if (yes) {
                            let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                            payload["counselling_id"] = counselling_id;
                            payload["clearance_id"] = clearance_id ? clearance_id : null;
                        }
                    }
                    if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
                        payload["form_type"] = 'add';
                        payload["counselling_id"] = '';
                        payload["clearance_id"] = clearance_id ? clearance_id : null;
                    }
                    if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
                        console.log('clearance_id', clearance_id);
                        const params = new URLSearchParams(this.props.location.search);
                        let ui_counselling_id = params.get('cid');
                        current_counselling_id = this.props.print_counselling_id || ui_counselling_id || '';
                        payload["form_type"] = 'view';
                        payload["counselling_id"] = current_counselling_id ? parseInt(current_counselling_id) : null;
                        payload["clearance_id"] = clearance_id ? clearance_id : null;
                    }
                    if(slug==='recounselling'){
                        payload["form_type"] = 'add';
                        payload["counselling_id"] = '';
                        payload["clearance_id"] =  null;
                    }
                    try {
                        postService(addFinancialClearance, 'POST', { 'data': payload }).then(res => {
                            console.log('financial response:', res);
                            if (res.status) {
                                Modal.success({
                                    title: `success`,
                                    content: `${res.message}`,
                                    zIndex: '1022'
                                });
                                if(slug==='recounselling'){
                                this.getPatientDocumentDetails('add');

                                }else{
                                    this.getPatientDocumentDetails();
                                }
                                this.fcOTMApp(umr_no,user_data['unitid'],clearance_text)
                                this.setState({ loadding: false, remarks_input: null,appointment_ids:[],selected_proceure:[],procedureList:[] })
                            } else {
                                Modal.error({
                                    title: `Failure`,
                                    content: `${res.message}`,
                                    zIndex: '1022'
                                });
                                this.getPatientDocumentDetails();
                                this.setState({ loadding: false, remarks_input: null,appointment_ids:[],selected_proceure:[],procedureList:[] })
                            }
                        })
                    } catch (error) {
                        console.log(error);
                        this.setState((state) => ({ 'loadding': false }));
                        Modal.error({
                            title: 'Error Message',
                            content: 'Oops, Something is wrong. Please try again.',
                        })
                    }
                } else {
                    Modal.error({
                        title: `Failure`,
                        content: `Request you to mention the  minimum 13 character length`,
                        zIndex: '1022'
                    });
                    this.setState({ loadding: false })
                }
            } else {
                Modal.error({
                    title: `Failure`,
                    content: `Please, Enter mandatory fields`,
                    zIndex: '1022'
                });
                this.setState({ loadding: false })
            }
        }else {
            //if (clearance_text && umr_no && user_data['unitid']) {
                if(clearance_text && (this.state.basicDetails.umr || umr_no || this.props.counselling_details.umr) && user_data['unitid']) {
                if (remarks_text && remarks_text.length > 12) {
                    // var num = body.id;
                    // var doc_id = num.toString();
                    let payload = {};
                    var current_counselling_id = '';
                    payload['financial_clearance'] = clearance_text;
                    payload['remarks'] = remarks_text;
                    payload["umr"] = umr_no;
                    // if (body['document_type'] === 'KYC') {
                    //     payload["ip_number"]= null;
                    // } else {
                    payload["ip_number"] = this.state.basicDetails.ip_no ? this.state.basicDetails.ip_no : ip_no ? ip_no : null;
                    // }
                    // payload["document_short_code"]= body.document_short_code;
                    // payload["document_id"]= doc_id;
                    payload["unit_id"] = user_data['unitid'];
                    if (slug === 'patients-history-details') {
                        payload["form_type"] = 'view';
                        let yes = this.props.mydata ? this.props.mydata : false;
                        if (yes) {
                            let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                            payload["counselling_id"] = counselling_id;
                            payload["clearance_id"] = clearance_id ? clearance_id : null;
                        }
                    }
                    if (slug === 'pending-docs') {
                        payload["form_type"] = 'view';
                        let yes = this.props.mydata ? this.props.mydata : false;
                        if (yes) {
                            let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                            payload["counselling_id"] = counselling_id;
                            payload["clearance_id"] = clearance_id ? clearance_id : null;
                        }
                    }
                    if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
                        console.log('clearance_idFC', clearance_id);
                        payload["form_type"] = 'add';
                        payload["counselling_id"] = '';
                        payload["clearance_id"] = clearance_id ? clearance_id : null;
                    }
                    if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
                        const params = new URLSearchParams(this.props.location.search);
                        let ui_counselling_id = params.get('cid');
                        current_counselling_id = this.props.print_counselling_id || ui_counselling_id || '';
                        payload["form_type"] = 'view';
                        payload["counselling_id"] = current_counselling_id ? parseInt(current_counselling_id) : null;
                        payload["clearance_id"] = clearance_id ? clearance_id : null;
                    }
                    if(slug==='recounselling'){
                        payload["form_type"] = 'add';
                        payload["counselling_id"] = '';
                        payload["clearance_id"] =  null;
                    }
                    try {
                        postService(addFinancialClearance, 'POST', { 'data': payload }).then(res => {
                            console.log('financial response:', res);
                            if (res.status) {
                                Modal.success({
                                    title: `success`,
                                    content: `${res.message}`,
                                    zIndex: '1022'
                                });
                                if(slug==='recounselling'){
                                this.getPatientDocumentDetails('add');

                                }else{
                                    this.getPatientDocumentDetails();
                                }
                                this.fcOTMApp(umr_no,user_data['unitid'],clearance_text)
                                this.setState({ loadding: false, remarks_input: null,appointment_ids:[],selected_proceure:[],procedureList:[] })
                            } else {
                                Modal.error({
                                    title: `Failure`,
                                    content: `${res.message}`,
                                    zIndex: '1022'
                                });
                                this.getPatientDocumentDetails();
                                this.setState({ loadding: false, remarks_input: null,appointment_ids:[],selected_proceure:[],procedureList:[] })
                            }
                        })
                    } catch (error) {
                        console.log(error);
                        this.setState((state) => ({ 'loadding': false }));
                        Modal.error({
                            title: 'Error Message',
                            content: 'Oops, Something is wrong. Please try again.',
                        })
                    }
                } else {
                    Modal.error({
                        title: `Failure`,
                        content: `Request you to mention the  minimum 13 character length`,
                        zIndex: '1022'
                    });
                    this.setState({ loadding: false })
                }
            } else {
                Modal.error({
                    title: `Failure`,
                    content: `Please, Enter mandatory fields`,
                    zIndex: '1022'
                });
                this.setState({ loadding: false })
            }
        }
    }

    fcOTMApp = (umr_no,unitid,clearance_text) =>{
        let {basic_info} = this.props
        let {appointment_ids} = this.state;
        let user_data 
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'));
        }
        try {
            otmpostService(updateFinancialClearanceinOTMApp, 'POST', {
                "data": {
                "umr": basic_info['umr_no'] ? basic_info['umr_no'] : umr_no || null,
                "unit_id": unitid ? unitid : null,
                "financial_clearance": clearance_text ? clearance_text : null,
                "appointment_id" : appointment_ids,
                "user_id":user_data['kims_userid'] ? user_data['kims_userid'] : null,
                }
                }).then(res => {
                console.log('otm financial response:', res);
                if (res.status) {
                    this.setState({ loadding: false })
                } else {
                    this.setState({ loadding: false })
                }
            })
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })
        }
    }
    
    remarks(event) {
        let value = event.target.value;
        this.setState((state) => ({ 'remarks_input': value ? value : null }));
    }
    commentsHistory = (data) => {
        let {umr_no}=this.state
        let This = this
        let user_data 
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'));
        }
        let umr = localStorage.getItem('UMRVALUE');
        try{
        This.setState((state) => ({ loadding: true }), () => {
            postService(getCounsellorCommentsByPatient, 'POST', {
                "data":{
                    "unit_id": user_data['unitid'] ? user_data['unitid'] : null,
                    "umr_no": umr ? umr : null
                }
            }).then(res => {
                console.log('comments:', res);                
                if (res.status) {                    
                    This.setState((state) => ({ 'loadding': false, 'commentsArray': res['data']})); 
                    this.setState({ loadding: false, appointment_ids:[],selected_proceure:[] }) 
                    this.procedureList();                  
                } else {
                    This.setState((state) => ({ 'loadding': false, 'commentsArray': [] }));
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                        zIndex: 1022
                    });
                }
            });
        });
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Failure',
            content: "Oops, something went wrong... Please try again.",
            zIndex: 1022
        });
    }        
    }
    financialPrintVisible(financialPrintVisible){
      let  basicDetail=[]
        if(financialPrintVisible){
            const basicInfoDetails = this.props.basic_info;
            // basicDetail=this.props.counselling_details?this.props.counselling_details:[] ;
            basicDetail=this.props.counselling_details?this.props.counselling_details: basicInfoDetails ;
            // this.getPatientDocumentDetails();
        }
        this.setState({financialPrintVisable:financialPrintVisible,basicDetails:basicDetail})
    }
    inputSearch(type, search_key) {
        console.log(search_key, type);
        if (type === 'procedure') {
          this.setState(
            (state) => ({ fetching: true, procedureList: [] }),
            () => {
              this.procedureList(search_key);
            }
          );
        }
    }
    procedureList = (search_key) => {
        let user_data 
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        const  {umr_no,ip_no} = this.props.basic_info; 
        let payload = {
          'umr_no': umr_no ? umr_no : null || '',
          'ip_number': ip_no ? ip_no : null || '',
          'unit_id' : user_data['unitid'] ? user_data['unitid'] : null,
        };
        this.setState(
          (state) => ({ fetching: true, procedureList: [] }),
          () => {
            otmpostService(getProceduresforFCApp, 'POST', {'data':payload}).then((res) => {
              if (res.status) {
                this.setState((state) => ({fetching: false,procedureList: res['data'],appointment_ids:[],selected_proceure:[]}));
              } else {
                this.setState((state) => ({ fetching: false, procedureList: [] }));
              }
            });
          }
        );
      };

    procedureSelect = (selectedItems) => {
        console.log("selectedItems 725",selectedItems);
        const selectedProcedureIds = selectedItems.map(item => item && item.appointment_id).filter(id => id !== undefined);
        this.setState({selected_proceure: selectedItems, appointment_ids: selectedItems, });
      }
    render() {
        let { tbody, showDocument, patientDocument, thead, umr_no, ip_no, patient_name, fileList, loadding, hideonHistory, ui_form_type, disable_15days,current_counselling_id, latest_counselling_id, formData, counselled_by, counselled_date, modal1Visible, remarks, remarks_input, commentsArray,basicDetails ,clearance,finanacialData,fetching,selected_proceure,procedureList,show_error,appointment_ids} = this.state
        let pat_doc_ids = []
        patientDocument.map((item, key1) => { pat_doc_ids.push(parseInt(item['document_id'])) })
        let { id, slug } = this.props.match.params
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
            slug = 'recounselling';
        }
        return (<React.Fragment>
                    {slug === 'patients-history-details' || slug === 'pending-docs' ? null : <React.Fragment> {showDocument ?
                        <div className={`col-10 mb-0 icon mx-auto p-3 text-center doc-ena`} style={{ backgroundColor: '#87979f' }} onClick={() => { this.setModal1Visible(true); this.initial() }}>                            
                            <InfoCircleFilled style={{ fontSize: 18, color: '#ffff' }} />
                        <p className="mt-2 mb-0">Financial Clearance</p>
                        </div>
                        :
                        <div className={`col-10 mb-0 icon mx-auto p-3 text-center doc-dis`} style={{ backgroundColor: '#87979f' }} >
                            <InfoCircleFilled style={{ fontSize: 18, color: '#ffff' }} />
                            <p className="mt-2 mb-0">Financial Clearance</p>
                        </div>
                    }</React.Fragment>}
                    <Modal
                        centered
                        visible={modal1Visible}
                        // onOk={() => this.includesOK()}
                        // onCancel={() => this.setModal1Visible(false)}
                        width='50%'
                        zIndex='1021'
                        closable={false}
                        maskClosable={false}
                        footer={null}
                    >
                        <Tooltip title='Close'><CloseOutlined type="close" className=" popup-close" onClick={() => this.setModal1Visible(false)} /></Tooltip>
                        {ui_form_type === 'view' && disable_15days == true ?
                            <React.Fragment>
                                <h4 className="text-center">Financial Clearance</h4>
                                <p className="text-center mb-5 text-danger">This counselling has expired, new changes are not allowed</p>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <h4 className="text-center">Financial Clearance</h4>
                                <p className="text-center mb-5">Confirm the financial clearance for this patient.</p>
                            </React.Fragment>}
                        {(loadding) && <div className="loadding h-100 w-100" style={{ left: 0,zIndex:9999 }}> <Spin ></Spin></div>}

                        {/* <div className="row pb-3">
                            <div className="col my-auto">
                                <h6 className="mb-0"> <Tooltip title="Patient Name">{patient_name ? patient_name : '--'}</Tooltip></h6>
                            </div>
                            <div className="col my-auto">
                                <h6 className="mb-0"> <Tooltip title="UMR Number">{umr_no ? umr_no : '--'}</Tooltip></h6>
                            </div>
                            <div className="col my-auto">
                                <h6 className="mb-0"> <Tooltip title="IP Number">{ip_no ? ip_no : '--'}</Tooltip></h6>
                            </div>
                        </div> */}
                        {/* {counselled_by && <h6 className="mb-0 text-center mb-5"> <Tooltip title="Last Updated By">{counselled_by ? counselled_by : ''}</Tooltip> <span className="mx-3">|</span> <Tooltip title="Last Updated at">{counselled_date ? moment(counselled_date).format('DD-MM-YYYY HH:mm') : ''}</Tooltip> <span className="mx-3">|</span> <Tooltip title="Last Remarks">{remarks ? remarks : ''}</Tooltip> </h6>} */}
                        <div className="col-12" style={{marginRight:'60px',marginBottom:'30px'}}>
                            <label>Surgeries</label>
                            <Select
                                mode="multiple"
                                showSearch
                                style={{ width: '100%' }}
                                dropdownClassName="custom-dropdown"
                                onChange={this.procedureSelect}
                                notFoundContent={fetching ? (<Spin size="small" />) : (<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />)}
                                filterOption={false}
                                value={appointment_ids}
                                onSearch={this.procedureList}
                                placeholder="Select Surgeries"
                            >
                                {procedureList.filter(data => data.procedure_name[0].trim() !== '')
                                .map((data, key) => (
                                    <Option key={key} value ={data.appointment_id}>
                                        <div style={{ whiteSpace: 'normal' }}>{data.procedure_name + ', ' + data.appointment_date + ', ' + data.start_time + ', ' + data.end_time}</div>
                                    </Option>
                                ))}
                            </Select>
                            {show_error && (
                                <React.Fragment>
                                {selected_proceure.length === 0 && 
                                    <small className="text-danger mt-2">
                                    Please Select Procedure Name
                                    </small>
                                }
                                </React.Fragment>
                            )}
                        </div>
                        <div className=" row">
                            {formData.map((feild, key) => {
                                if (feild.visible && feild.element === 'radio') {
                                    return <React.Fragment key={key}>
                                        <div className="col-6 mx-auto">{feild.data.map((radio, key) => {
                                            return (<div className="w-50 d-inline-flex radio-button">
                                                <RadioButtonLayer selectdata={radio}
                                                    changedObj={this.state.changedObj}
                                                    {...this.props}
                                                    {...this.state}
                                                    Queuedata={this.state.formData}
                                                    onselectChanges={this.handleChange.bind(this)} />

                                            </div>)
                                        })}
                                            {feild.errors.map((error, eKey) => {
                                                return (
                                                    <small key={eKey} className="form-text text-danger" style={{ bottom: '-15px' }}>{error.message}</small>
                                                );
                                            })}
                                        </div>
                                    </React.Fragment>
                                }

                            })}
                            {((finanacialData.length>0 &&slug==='view-finanical-counselling') ||( finanacialData.length>0 &&slug==='recounselling') ||( finanacialData.length>0 &&slug==='finanical-counselling'))&&<div className="col-4 text-right mx-auto ">
                                <Tooltip placement="top" title='Click To Print'>
                                    <img src="/assets/images/pdf.png" className="print-pdf-img-financialclear" onClick={() => this.financialPrintVisible(true)}/>
                                </Tooltip>
                                {/* <p className="mb-0">Comment</p> */}
                            </div>}      
                        </div>
                        {!disable_15days && <React.Fragment>
                            <div className="row w-100 mx-auto mt-3">
                                <div class="col-12 p-0">
                                    <textarea placeholder="Enter your remarks..." autoFocus='true' className="textarea" style={{ height: '80px' }} value={remarks_input ? remarks_input : ''} onChange={(event) => this.remarks(event)}></textarea>
                                </div>
                            </div>
                            <div className="text-right">
                                <button className="btn btn-success" onClick={() => { this.fc_submit() }}>Submit</button>
                            </div>
                        </React.Fragment>}
                        <div class="row pt-3">
                            {commentsArray.map((data,key)=>{                                
                                return <div className="col-12 pb-3">
                                    <div class="media">                                       
                                        <div class="align-self-start mr-3">
                                        <Avatar size={50} icon={<UserOutlined />} className="align-middle"/>
                                        </div>
                                        <div class="media-body">
                                        <h6 className='mb-1'><Tooltip title="Created By">{data.created_by}</Tooltip> <span className="mx-3">|</span> <Tooltip title='Created On'><small className="text-muted">{moment(data.created_at).format('DD-MM-YYYY LT')}</small></Tooltip> <span className="mx-3">|</span> <Tooltip title="Comment From"><small className="text-capitalize text-muted"> {data.remarks_from}</small></Tooltip></h6>
                                            <p>{data.remarks}</p>
                                        </div>
                                    </div>
                                </div>
                            })}
                            {commentsArray && commentsArray.length == 0 && <Empty className="mx-auto" description={<span>No history is available for this patient.</span> }/>}
                        </div>
                    </Modal>
{/* financial Clearance */}
                    <Modal
                                        // title="Clearance"
                                        centered
                                        visible={this.state.financialPrintVisable}
                                        footer={null}
                                        onOk={() => this.financialPrintVisible(false)}
                                        onCancel={() => this.financialPrintVisible(false)}
                                        width='100%'
                                        zIndex={1021}
                                    >
                                        <Spin spinning={this.state.loadding}>
                                            <div ref={(el) => (this.componentRef = el)} >
                                                <React.Fragment>
                                                    <div className="fc-patient-copy">
                                                        <div className="p-4 bg-white" id="myH1">
                                                            <div className="clearfix">
                                                                <img src="/assets/images/logo-black.png" alt="Kims" className="float-left"></img>
                                                                <p className="float-right align-middle pb-0 my-2 ">KIMS/FO-01</p>
                                                            </div>

                                                            <div>
                                                                <h1 className="text-p-bold text-center text-uppercase py-4">Surgery Financial Clearance Form</h1>
                                                            </div>
                                                            {slug === 'finanical-counselling' ? 
                                                            <div className="row m-0 pb-3 border">
                                                                {/* {basicDetails['counselling_date'] && */}
                                                                <div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Date of Counselling</span>
                                                                        <span className="w-100">: {basicDetails['counselling_date']?moment(basicDetails['counselling_date']).format('DD-MM-YYYY'):'--'}</span>
                                                                    </div>
                                                                </div>
                                                                {/* } */}
                                                                {basicDetails['counselling_type_name']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Counselling type</span>
                                                                        <span className="w-100">: {basicDetails['counselling_type_name']?basicDetails['counselling_type_name']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['umr_no']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">UMR number</span>
                                                                        <span className="w-100">: {basicDetails['umr_no']?basicDetails['umr_no']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['ip_no']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">IP number</span>
                                                                        <span className="w-100">: {basicDetails['ip_no']?basicDetails['ip_no']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                               {basicDetails['covid_status']&& <div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Covid Status</span>
                                                                    <span className="w-100">: {basicDetails['covid_status'] ?basicDetails['covid_status']:''}</span>
                                                                </div>
                                                            </div>}
                                                                {basicDetails['patient_name']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Patient Name</span>
                                                                        <span className="w-100">: {basicDetails['patient_name']?basicDetails['patient_name']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['phone_no']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Patient Phone No.</span>
                                                                        <span className="w-100">: {basicDetails['phone_no']?basicDetails['phone_no']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['age']&&
                                                                <div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Patient Age</span>
                                                                        <span className="w-100">: {basicDetails['age']?basicDetails['age']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {/* {basicDetails['gender']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Patient Gender</span>
                                                                        <span className="w-100">: {basicDetails['gender']?basicDetails['gender']:'--'}</span>
                                                                    </div>
                                                                </div>} */}
                                                               {/* { basicDetails['marital_status']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Patient Marital</span>
                                                                        <span className="w-100">: {basicDetails['marital_status']?basicDetails['marital_status']:'--'}</span>
                                                                    </div>
                                                                </div>} */}
                                                               {/* {basicDetails['address']&& <div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Patient Address</span>
                                                                        <span className="w-100">: {basicDetails['address']?basicDetails['address']:'--'}</span>
                                                                    </div>
                                                                </div>} */}
                                                                {basicDetails['doctor_name']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Doctor Name</span>
                                                                        <span className="w-100">: {basicDetails['doctor_name']?basicDetails['doctor_name']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['speciality_name']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Specialty</span>
                                                                        <span className="w-100">: {basicDetails['speciality_name']?basicDetails['speciality_name']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['care_management_name']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Care Management</span>
                                                                        <span className="w-100">: {basicDetails['care_management_name']?basicDetails['care_management_name']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['estimate_type_name']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Estimate Type</span>
                                                                        <span className="w-100">: {basicDetails['estimate_type_name']?basicDetails['estimate_type_name']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['payment_type']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Mode of Payment</span>
                                                                        <span className="w-100">: {basicDetails['payment_type']?basicDetails['payment_type']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['insurance_company_name']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Insurance </span>
                                                                        <span className="w-100">: {basicDetails['insurance_company_name']?basicDetails['insurance_company_name']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['tpa_name']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">TPA </span>
                                                                        <span className="w-100">: {basicDetails['tpa_name']?basicDetails['tpa_name']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['insurance_status_name']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Pre Auth Status </span>
                                                                        <span className="w-100">: {basicDetails['insurance_status_name']?basicDetails['insurance_status_name']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['date_of_surgery']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Date of surgery </span>
                                                                        <span className="w-100">: {basicDetails['date_of_surgery']?moment(basicDetails['date_of_surgery']).format('DD-MM-YYYY'):'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['e_date_of_admission']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Estimated Date of Admission</span>
                                                                        <span className="w-100">: {basicDetails['e_date_of_admission']?moment(basicDetails['e_date_of_admission']).format('DD-MM-YYYY'):'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['date_of_admission']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Date of Admission</span>
                                                                        <span className="w-100">: {basicDetails['date_of_admission']?moment(basicDetails['date_of_admission']).format('DD-MM-YYYY'):'--'}</span>
                                                                    </div>
                                                                </div>}
                                                               {basicDetails['procedure_name']&& <div className="col-8">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Surgery Name </span>
                                                                        <span className="w-100">: {basicDetails['procedure_name']?basicDetails['procedure_name']:'--'}</span>
                                                                    </div>
                                                                </div>}
                                                                {basicDetails['package_name']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Package Name</span>
                                                                    <span className="w-100">: {basicDetails['package_name']?basicDetails['package_name']:'---'}</span>
                                                                </div>
                                                            </div>}
                                                            </div>
                                                            : 
                                                            <div className="row m-0 pb-3 border">
                                                            {basicDetails['counselling_date'] &&
                                                            <div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Date of Counselling</span>
                                                                    <span className="w-100">: {basicDetails['counselling_date']?moment(basicDetails['counselling_date']).format('DD-MM-YYYY'):'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['counselling_type_name']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Counselling type</span>
                                                                    <span className="w-100">: {basicDetails['counselling_type_name']?basicDetails['counselling_type_name']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['umr']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">UMR number</span>
                                                                    <span className="w-100">: {basicDetails['umr']?basicDetails['umr']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['ip_no']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">IP number</span>
                                                                    <span className="w-100">: {basicDetails['ip_no']?basicDetails['ip_no']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                           {basicDetails['covid_status']&& <div className="col-4 ">
                                                            <div className="d-inline-flex">
                                                                <span className="w-label">Covid Status</span>
                                                                <span className="w-100">: {basicDetails['covid_status'] ?basicDetails['covid_status']:''}</span>
                                                            </div>
                                                        </div>}
                                                            {basicDetails['patient_name']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Patient Name</span>
                                                                    <span className="w-100">: {basicDetails['patient_name']?basicDetails['patient_name']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['patient_phno']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Patient Phone No.</span>
                                                                    <span className="w-100">: {basicDetails['patient_phno']?basicDetails['patient_phno']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['age']&&
                                                            <div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Patient Age</span>
                                                                    <span className="w-100">: {basicDetails['age']?basicDetails['age']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {/* {basicDetails['gender']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Patient Gender</span>
                                                                    <span className="w-100">: {basicDetails['gender']?basicDetails['gender']:'--'}</span>
                                                                </div>
                                                            </div>} */}
                                                           {/* { basicDetails['marital_status']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Patient Marital</span>
                                                                    <span className="w-100">: {basicDetails['marital_status']?basicDetails['marital_status']:'--'}</span>
                                                                </div>
                                                            </div>} */}
                                                           {/* {basicDetails['address']&& <div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Patient Address</span>
                                                                    <span className="w-100">: {basicDetails['address']?basicDetails['address']:'--'}</span>
                                                                </div>
                                                            </div>} */}
                                                            {basicDetails['doctor_name']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Doctor Name</span>
                                                                    <span className="w-100">: {basicDetails['doctor_name']?basicDetails['doctor_name']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['doctor_speciality']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Specialty</span>
                                                                    <span className="w-100">: {basicDetails['doctor_speciality']?basicDetails['doctor_speciality']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['care_management_name']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Care Management</span>
                                                                    <span className="w-100">: {basicDetails['care_management_name']?basicDetails['care_management_name']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['estimate_type_name']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Estimate Type</span>
                                                                    <span className="w-100">: {basicDetails['estimate_type_name']?basicDetails['estimate_type_name']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['payment_type']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Mode of Payment</span>
                                                                    <span className="w-100">: {basicDetails['payment_type']?basicDetails['payment_type']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['insurance_company_name']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Insurance </span>
                                                                    <span className="w-100">: {basicDetails['insurance_company_name']?basicDetails['insurance_company_name']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['tpa_name']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">TPA </span>
                                                                    <span className="w-100">: {basicDetails['tpa_name']?basicDetails['tpa_name']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['insurance_status_name']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Pre Auth Status </span>
                                                                    <span className="w-100">: {basicDetails['insurance_status_name']?basicDetails['insurance_status_name']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['date_of_surgery']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Date of surgery </span>
                                                                    <span className="w-100">: {basicDetails['date_of_surgery']?moment(basicDetails['date_of_surgery']).format('DD-MM-YYYY'):'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['e_date_of_admission']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Estimated Date of Admission</span>
                                                                    <span className="w-100">: {basicDetails['e_date_of_admission']?moment(basicDetails['e_date_of_admission']).format('DD-MM-YYYY'):'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['date_of_admission']&&<div className="col-4 ">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Date of Admission</span>
                                                                    <span className="w-100">: {basicDetails['date_of_admission']?moment(basicDetails['date_of_admission']).format('DD-MM-YYYY'):'--'}</span>
                                                                </div>
                                                            </div>}
                                                           {basicDetails['procedure_name']&& <div className="col-8">
                                                                <div className="d-inline-flex">
                                                                    <span className="w-label">Surgery Name </span>
                                                                    <span className="w-100">: {basicDetails['procedure_name']?basicDetails['procedure_name']:'--'}</span>
                                                                </div>
                                                            </div>}
                                                            {basicDetails['package_name']&&<div className="col-4 ">
                                                            <div className="d-inline-flex">
                                                                <span className="w-label">Package Name</span>
                                                                <span className="w-100">: {basicDetails['package_name']?basicDetails['package_name']:'---'}</span>
                                                            </div>
                                                        </div>}
                                                        </div>}
                                                            <div className="row m-0 mt-3 pb-3 border">
                                                            <div className="col-4">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Clearance given by</span>
                                                                        <span className="w-100">: {counselled_by ? counselled_by : null}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-4">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Date</span>
                                                                        <span className="w-100">: {counselled_date ? moment(counselled_date).format('DD-MM-YYYY') : null}</span>
                                                                    </div>
                                                                </div>
                                                            <div className="col-4">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label" style={{minWidth:'190px'}}>Financial Clearance given : </span>
                                                                        <span className="w-100"> {clearance ? clearance  : null}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Remarks : </span>
                                                                        <span className="w-100">{remarks ? remarks : null}</span>
                                                                    </div>
                                                                </div>
                                                                <p></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            </div>
                                            <div className="fc-patient-copy">
                                                <div className="row justify-content-center p-4 pt-4 m-0">
                                                    <ReactToPrint
                                                        // trigger={() => <a href="#">Print this out!</a>}
                                                        trigger={() => <button className="btn btn-success d-print-none text-capitalize">Print</button>}
                                                        content={() => this.componentRef}
                                                    />
                                                    <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.financialPrintVisible(false)}>cancel</button>
                                                </div>
                                            </div>
                                        </Spin>
                                    </Modal>

                {/* </React.Fragment>
            </div> */}
        </React.Fragment>)
    }
}
export default Finanical_clearance;